import React from 'react';
import { DraggableModal } from '@ui/shared/components/Common/DraggableModal';
import CONSTANTS from '../../../config/constants';
import AnnotationsList from './index';

const DraggableAnnotationsModal = ({ 
  isOpen, 
  onClose, 
  initialPosition,
  initialSize = { width: 700, height: 500 }
}) => {
  return (
    <DraggableModal
      isOpen={isOpen}
      onClose={onClose}
      title="Annotations"
      initialPosition={initialPosition}
      initialSize={initialSize}
      resizable={true}
      minimizable={true}
      minSize={{ width: 400, height: 300 }}
      maxSize={{ width: 1400, height: 1000 }}
      constrainToContainer={false}
      keyboardShortcuts={{
        close: CONSTANTS?.KEYBOARD_SHORTCUTS?.ANNOTATIONS?.OPTIONS?.FLOATING_MODAL?.KEY || 'escape',
        minimize: 'ctrl+m'
      }}
      id="annotations-modal"
      contentStyle={{
        padding: '0'
      }}
    >
      <AnnotationsList />
    </DraggableModal>
  );
};

export default DraggableAnnotationsModal;
